export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
